import React from 'react';
import { AppBar, Toolbar, Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import GrpIconButton from './GrpIconButton';
import FloatingPhoneButton from './FloatingPhoneButton';
import { useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import UserAccountMenuDrawer from "./UserAccountMenuDrawer"


const StickyHeader: React.FC = () => {

  const theme = useTheme();
  const navigate = useNavigate();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  return (
    <>
      <FloatingPhoneButton></FloatingPhoneButton>
      <AppBar
      id="sticky-header"
        position="sticky"
        sx={{
          top: 0,
          zIndex: 1100, 
          width: "100%",
          backgroundColor: 'white', //#3f51b5
          color: 'green',
          paddingLeft: '1px',
          paddingRight: '0px',
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', padding: '0 0' }}>
          <Box sx={{ display: 'flex', alignItems: 'left' }} component={Link} to="/">
            <img src={logo} alt="Logo" style={{ marginRight: '2px', height: isMobile ? '42px' : '44px' }} />
          </Box>
          <Box >
            {isMobile ? (
              <Box >
                <GrpIconButton name={'Book Ride'} redirectUrl={'/book-now'} ></GrpIconButton>
                &nbsp;&nbsp;
                {/* <UserAccountMenuDrawer /> */}
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  style={{ marginRight: '1px', height: '44px' }}
                  onClick={handleMenuOpen}
                >
                  <MenuIcon fontSize="large" />
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handleMenuClose} component={Link} to="/book-now">Book Your Green Ride</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/why-grp">Why Green Rides Pune?</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/extra-safety">Extra Safety Measures</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/grp-users">GRP User</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/grp-partner-users">GRP Partners</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/grp-business-users">GRP Business/Corporate Users</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/grp-drivers">GRP Drivers</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/contactus">Contact Us</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/termsandconditions">Terms & Conditions</MenuItem>
                  <MenuItem onClick={handleMenuClose} component={Link} to="/privacypolicy">Privacy Policy</MenuItem>
                </Menu>
              </Box>
            ) : (
                <Box >
                  <Link to="/" className="menulink">HOME</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Link to="/book-now" className="menulink">BOOK RIDE NOW</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Link to="/why-grp" className="menulink">WHY GREEN RIDES?</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Link to="/extra-safety" className="menulink">EXTRA SAFETY MEASURES</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Link to="/contactus" className="menulink">CONTACT US</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                  {/* <UserAccountMenuDrawer /> */}
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    style={{ marginRight: '1px', height: '44px' }}
                    onClick={handleMenuOpen}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={handleMenuClose} component={Link} to="/grp-users">GRP User</MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/grp-drivers">GRP Drivers</MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/grp-partner-users">GRP Partners</MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/grp-business-users">GRP Business/Corporate Users</MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/termsandconditions">Terms & Conditions</MenuItem>
                    <MenuItem onClick={handleMenuClose} component={Link} to="/privacypolicy">Privacy Policy</MenuItem>
                  </Menu>
                </Box>
              )}
          </Box>
        </Toolbar>
      </AppBar>

    </>
  );
};

export default StickyHeader;
